import cn from 'classnames';
import React, { memo, useMemo } from 'react';

import { Layout } from '@sravni/react-design-system/lib/Layout';

import { usePageContext } from '@src/config/PageContext';
import { ListKeys } from '@src/constants/microcredits';
import { typograf } from '@src/helpers/typograf';
import { DisclaimerHelper } from 'shared/ui/DisclaimerHelper';

import { DEFAULT_DISCLAIMER, GURULEADS_DISCLAIMER, KZ_DISCLAIMER } from './consts';
import styles from './styles.module.scss';
import type { IDisclaimer } from './types';

interface IProps {
  disclaimers?: IDisclaimer[];
  className?: string;
}

const Disclaimer: React.FC<IProps> = memo(({ disclaimers, className }) => {
  const { listKey } = usePageContext();

  const disclaimer = useMemo(() => {
    if (disclaimers) {
      return disclaimers;
    }

    switch (listKey) {
      case ListKeys.GURULEADS:
        return GURULEADS_DISCLAIMER;

      case ListKeys.KAZAKHSTAN:
        return KZ_DISCLAIMER;

      default:
        return DEFAULT_DISCLAIMER;
    }
  }, [listKey, disclaimers]);

  return (
    <DisclaimerHelper>
      <div className={cn(styles.container, className)}>
        <Layout className={styles.layout}>
          <div className={styles.text}>
            {disclaimer.map(({ id, text, isTitle }) => (
              <p className={cn({ [styles.title]: isTitle })} key={id}>
                {typograf.execute(text)}
              </p>
            ))}
          </div>
        </Layout>
      </div>
    </DisclaimerHelper>
  );
});

export default Disclaimer;
